// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetEstimationSaleWebRequest,
  TGetEstimationSaleWebModel,
  IMappers,
  TGetEstimationSaleWebResponse,
  IGetEstimationSaleWebResponse,
  IGetEstimationSaleWebResponseError,
} from './types';

export const defaultConfig: TGetEstimationSaleWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-sale-web/',
  requestType: 'json',
} as TGetEstimationSaleWebModel;

export function createGetEstimationSaleWebModel(parameters: IGetEstimationSaleWebRequest): TGetEstimationSaleWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationSaleWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetEstimationSaleWebRequest;
}

export async function fetchGetEstimationSaleWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationSaleWebOptions<TResponse200, TResponse400>): Promise<
  TGetEstimationSaleWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetEstimationSaleWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationSaleWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationSaleWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetEstimationSaleWebResponse;
}
